// removed by extract-text-webpack-plugin
module.exports = {"button":"DeleteForm__button___oxL0_"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/components/deletes/DeleteForm.css
// module id = 1209
// module chunks = 0